import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH } from "@jti/fe-common/constants";
import type { DeviceAllowedCodeLength, DeviceRegistrationConfiguration } from "@jti/fe-common/types";
import type { RegisterDeviceDialogProps } from "@jti/ui/components/RegisterDeviceDialog";

const getRequiredCodeLength = ({
  is12DeviceCodeLength,
  is15DeviceCodeLength,
  is16DeviceCodeLength,
}: {
  is12DeviceCodeLength?: string | boolean;
  is15DeviceCodeLength?: string | boolean;
  is16DeviceCodeLength?: string | boolean;
}) => {
  const requiredCodeLength: DeviceAllowedCodeLength[] = [];
  if (is12DeviceCodeLength) {
    requiredCodeLength.push(12);
  }
  if (is15DeviceCodeLength) {
    requiredCodeLength.push(15);
  }
  if (is16DeviceCodeLength) {
    requiredCodeLength.push(16);
  }
  if (requiredCodeLength.length === 0) {
    requiredCodeLength.push(16);
  }
  return requiredCodeLength;
};

const getRegisterDeviceAccordionImagesContent = ({
  accordionImageOne,
  accordionImageOneAlt,
  accordionImageOneDescription,
  accordionImageTwo,
  accordionImageTwoAlt,
  accordionImageTwoDescription,
}: {
  accordionImageOne?: string;
  accordionImageOneAlt?: string;
  accordionImageOneDescription?: string;
  accordionImageTwo?: string;
  accordionImageTwoAlt?: string;
  accordionImageTwoDescription?: string;
}) =>
  [
    {
      imageUrl: accordionImageOne || "",
      imageAlt: accordionImageOneAlt || "",
      description: accordionImageOneDescription || "",
    },
    {
      imageUrl: accordionImageTwo || "",
      imageAlt: accordionImageTwoAlt || "",
      description: accordionImageTwoDescription || "",
    },
  ].filter((item) => item.imageUrl && item.imageAlt && item.description);

export const deviceConfigurationToRegisterDialogPropsAdapter = (
  config: DeviceRegistrationConfiguration | undefined
): Omit<RegisterDeviceDialogProps, "isOpened" | "onClose" | "onDeviceRegistrationSuccess"> => {
  const {
    theme,
    registerDeviceImgDesktop,
    registerDeviceImgMobile,
    registerDeviceImgAlt,
    registerDeviceDialogTitle,
    registerDeviceDialogDescription,
    registerDeviceAccordionTitle,
    registerDeviceAccordionButtonUrl,
    registerDeviceAccordionButtonText,
    cancelDeviceRegistrationButtonText,
    confirmDeviceRegistrationButtonText,
    isDeviceCodeFormatLabelVisible,
    is12DeviceCodeLength,
    is15DeviceCodeLength,
    is16DeviceCodeLength,
    accordionImageOne,
    accordionImageOneAlt,
    accordionImageOneDescription,
    accordionImageTwo,
    accordionImageTwoAlt,
    accordionImageTwoDescription,
  } = config || {};

  return {
    imageAlt: registerDeviceImgAlt ?? "",
    title: registerDeviceDialogTitle || "",
    theme,
    imgMobile: registerDeviceImgMobile || "",
    imgDesktop: registerDeviceImgDesktop || "",
    description: registerDeviceDialogDescription || "",
    cancelButtonText: cancelDeviceRegistrationButtonText || "",
    confirmButtonText: confirmDeviceRegistrationButtonText || "",
    registerDeviceAccordionTitle: registerDeviceAccordionTitle || "",
    registerDeviceAccordionButtonUrl: registerDeviceAccordionButtonUrl || "",
    registerDeviceAccordionButtonText: registerDeviceAccordionButtonText || "",
    isDeviceCodeFormatLabelVisible: isDeviceCodeFormatLabelVisible ?? true,
    requiredCodeLength:
      getRequiredCodeLength({
        is12DeviceCodeLength,
        is15DeviceCodeLength,
        is16DeviceCodeLength,
      }) || DEFAULT_ALLOWED_DEVICE_CODE_LENGTH,
    registerDeviceAccordionImagesContent: getRegisterDeviceAccordionImagesContent({
      accordionImageOne,
      accordionImageOneAlt,
      accordionImageOneDescription,
      accordionImageTwo,
      accordionImageTwoAlt,
      accordionImageTwoDescription,
    }),
  };
};
